import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface UserRef {
  _id: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  role?: string;
}

export interface PermissionConnect {
  chat: boolean;
  meeting: boolean;
}

export interface PermissionAttendance {
  admin: boolean;
  employee: boolean;
}

export interface PermissionEmployees {
  department: boolean;
  leaveEmployees: boolean;
  adminLeave: boolean;
  leaveConfiguration: boolean;
}

export interface PermissionReports {
  leaveReports: boolean;
  attendanceReports: boolean;
}

export interface Permissions {
  connect?: PermissionConnect;
  attendance?: PermissionAttendance;
  employees?: PermissionEmployees;
  reports?: PermissionReports;

  dashboard?: boolean;
  projects?: boolean;
  allProjects?: boolean;
  notifications?: boolean;
  ourClients?: boolean;
  userProfile?: boolean;
  holidays?: boolean;
  adminSettings?: boolean;
  superAdminPanel?: boolean;

  [key: string]: any;
}

export interface UserPermission {
  _id: string;
  userId: UserRef;
  role: string;
  organizationId?: string;
  permissions: Permissions;
  custom?: boolean;
  createdBy?: UserRef;
  createdAt?: string;
  updatedAt?: string;
  __v?: number;
}

export interface UserPermissionsResponse {
  success: boolean;
  data: UserPermission;
  message?: string;
}

export const fetchUserPermissions = async (
  userId: string
): Promise<UserPermissionsResponse> => {
  const response = await customAxios.get<UserPermissionsResponse>(
    `/permissions/users/${userId}`
  );
  return response.data;
};

export const useGetUserPermissions = (
  userId: string,
  options?: { enabled?: boolean }
) =>
  useQuery<UserPermissionsResponse, AxiosError>(
    ["userPermissions", userId],
    () => fetchUserPermissions(userId),
    {
      enabled: options?.enabled ?? !!userId,
      // onError: (error) =>
      //   showNotification({
      //     title: "Error Loading Permissions",
      //     message:
      //       (error.response?.data as { message?: string })?.message ??
      //       "Failed to load user permissions",
      //     color: "red",
      //   }),
      staleTime: 1000 * 60 * 60 * 24,
      cacheTime: 1000 * 60 * 60 * 24,
      retry: 1,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );
